import { render } from "./Result.vue?vue&type=template&id=ed601aac"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&id=ed601aac&lang=postcss"
script.render = render

export default script